/* eslint-disable no-param-reassign */
import commonApi from '@/apis/common';

export default {
  namespaced: true,
  state: () => ({
    abc: {
      fetched: false,
      codes: [],
    },
  }),
  mutations: {
    set(state, payload) {
      state.abc.codes = payload;
      state.abc.fetched = true;
    },
  },
  actions: {
    async set({ commit }) {
      const r = await commonApi.getABCInformation();
      commit('set', r);
    },
  },
  getters: {
    abc: (state) => state.abc.codes,
    abcFectched: (state) => state.abc.fetched,
  },
};
